<form-layout [showSave]="false" (onSave)="onSaveClick()" (onBack)="onBackClick()" (onNext)="onSaveAndNextClick()">
    <div>
        <kendo-grid [data]="gridView" (remove)="removeHandler($event)" [sort]="sort" [sortable]="true">
            <kendo-grid-column [width]="90">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button class="cancel-button" (click)="openAenderungsantrag(dataItem.id)" [title]="'mitantragsteller.grid.details' | translate">
                        <i-lucide name="external-link" [size]="18"></i-lucide>
                    </button>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="{{'mitantragsteller.name' | translate}}" field="firstname">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div *ngIf="dataItem?.firstname != null || dataItem?.firstname != ''"
                        [attr.id]="'rowheader-' + rowIndex">
                        <span>
                            {{ dataItem.firstname }} {{ dataItem.lastname }}
                        </span>
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="{{'mitantragsteller.email' | translate}}" field="emailAddress">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div *ngIf="dataItem?.emailAddress != null || dataItem?.emailAddress != ''"
                        [attr.aria-labelledby]="'rowheader-' + rowIndex">
                        <span>
                            {{ dataItem.emailAddress }}
                        </span>
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-command-column [width]="80" *ngIf="!formGroup.disabled">
                <ng-template kendoGridCellTemplate let-isNew="isNew" let-rowIndex="rowIndex">
                    <button kendoGridRemoveCommand [title]="'mitantragsteller.grid.delete' | translate"
                        [attr.aria-labelledby]="'rowheader-' + rowIndex + ' delete-label'" class="cancel-button">
                        <i class="fa fa-trash"></i>
                    </button>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
    </div>

    <div class="mt-4">
        <button kendoButton class="confirm-button" (click)="createHandler()" *ngIf="!formGroup.disabled && !isFormOpen">
            <span translate>mitantragsteller.grid.add</span>
            <i class="fa fa-plus" style="margin-left: 0.5rem;"></i>
        </button>
    </div>

    <form [formGroup]="mitantragstellerForm" *ngIf="isFormOpen">

        <div class="mitantragsteller-vertical">

            <div class="combobox-field">
                <kendo-formfield>
                    <kendo-label class="form-label" [for]="anrede"
                        text="{{'mitantragsteller.salutation' | translate}} *"
                        [infotooltip]="'mitantragsteller.anrede'"></kendo-label>
                    <kendo-combobox formControlName="anredeId" #anrede [valuePrimitive]="true" [allowCustom]="false"
                        [data]="anredeItems" [valueField]="'anredeId'" [textField]="'name'"
                        [appinfotext]="'mitantragsteller.anrede'" kendoDropDownFilter (valueChange)="loadAnreden()">
                    </kendo-combobox>
                </kendo-formfield>
            </div>

            <div class="textbox-field">
                <kendo-formfield>
                    <kendo-label class="form-label" [for]="firstname"
                        text="{{'mitantragsteller.firstname' | translate}} *"
                        [infotooltip]="'mitantragsteller.vorname'"></kendo-label>
                    <kendo-textbox #firstname formControlName="firstname" showSuccessIcon="initial"
                        showErrorIcon="initial" [appinfotext]="'mitantragsteller.vorname'" preventEmptyFormatter
                        [maxlength]=90
                        (paste)="this.textBoxService.onPaste($event, this.mitantragstellerForm.Firstname, 90)">
                    </kendo-textbox>
                </kendo-formfield>
            </div>
            
            <div class="textbox-field">
                <kendo-formfield>
                    <kendo-label class="form-label" [for]="lastname"
                        text="{{'mitantragsteller.lastname' | translate}} *"
                        [infotooltip]="'mitantragsteller.nachname'"></kendo-label>
                    <kendo-textbox #lastname formControlName="lastname" showSuccessIcon="initial"
                        showErrorIcon="initial" [appinfotext]="'mitantragsteller.nachname'" preventEmptyFormatter
                        [maxlength]=90
                        (paste)="this.textBoxService.onPaste($event, this.mitantragstellerForm.Lastname, 90)">
                    </kendo-textbox>
                </kendo-formfield>
            </div>

            <div class="textbox">
                <kendo-formfield>
                    <kendo-label class="form-label" [for]="email" text="{{'mitantragsteller.email' | translate}} *"
                        [infotooltip]="'mitantragsteller.emailadresse'"></kendo-label>
                    <kendo-textbox #email formControlName="emailAddress" showSuccessIcon="initial"
                        showErrorIcon="initial" [appinfotext]="'mitantragsteller.emailadresse'" preventEmptyFormatter
                        [maxlength]=100
                        (paste)="this.textBoxService.onPaste($event, this.mitantragstellerForm.EmailAddress, 100)"></kendo-textbox>
                    <kendo-formerror *ngIf="emailErrorMessage">{{emailErrorMessage}}</kendo-formerror>
                </kendo-formfield>
            </div>
        </div>

        <div class="mitantragsteller-button-group">
            <button kendoButton class="cancel-button" (click)="cancelForm()">
                {{'schedule-data.dialog.cancel' | translate}}
            </button>
            <button kendoButton class="confirm-button" (click)="saveMitantragsteller(false)"
                [disabled]="!mitantragstellerForm.valid">
                {{'question.save' | translate}}
            </button>
            <button kendoButton class="confirm-button" (click)="saveMitantragsteller(true); "
                [disabled]="!mitantragstellerForm.valid">
                {{'question.save.open' | translate}}
            </button>
        </div>
    </form>
</form-layout>
